var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block text-2xl font-bold text-sky-600"},[_c('div',{staticClass:"flex items-center gap-[0.35rem]"},[_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }